import React, { Component } from 'react';
import './reader-settings.css';
import {
  loadReaderSettings,
  saveReaderSettings,
  applyReaderSettings,
  getTextColor,
  COLORS,
  FONT_LIST,
  FONT_SIZE_MIN,
  FONT_SIZE_MAX
} from '../../utils/readerSettings';

const EXCLUDED_ROUTES = [
  '/livro/',
  '/player/',
  '/login',
  '/cadastro',
  '/sso/',
  '/recover-password',
  '/user/forgot'
];

function shouldShow() {
  var hash = window.location.hash.replace('#', '') || window.location.pathname;
  for (var i = 0; i < EXCLUDED_ROUTES.length; i++) {
    if (hash.indexOf(EXCLUDED_ROUTES[i]) === 0) return false;
  }
  return true;
}

export default class ReaderSettings extends Component {
  constructor(props) {
    super(props);
    var settings = loadReaderSettings();
    this.state = {
      visible: shouldShow(),
      open: false,
      ...settings
    };
  }

  componentDidMount() {
    this.applyCurrent();
    window.addEventListener('hashchange', this.handleHashChange);
    window.addEventListener('reader-settings-changed', this.handleExternalChange);
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.handleHashChange);
    window.removeEventListener('reader-settings-changed', this.handleExternalChange);
  }

  handleExternalChange = () => {
    var settings = loadReaderSettings();
    this.setState(settings);
  };

  handleHashChange = () => {
    this.setState({ visible: shouldShow() });
  };

  applyCurrent() {
    applyReaderSettings({
      fontSize: this.state.fontSize,
      fontFamily: this.state.fontFamily,
      backgroundColor: this.state.backgroundColor,
      textColor: this.state.textColor,
      highContrast: this.state.highContrast,
      dyslexiaFont: this.state.dyslexiaFont
    });
  }

  persistAndApply(updates) {
    var settings = {
      fontSize: updates.fontSize != null ? updates.fontSize : this.state.fontSize,
      fontFamily: updates.fontFamily != null ? updates.fontFamily : this.state.fontFamily,
      backgroundColor: updates.backgroundColor != null ? updates.backgroundColor : this.state.backgroundColor,
      textColor: updates.textColor != null ? updates.textColor : this.state.textColor,
      highContrast: updates.highContrast != null ? updates.highContrast : this.state.highContrast,
      dyslexiaFont: updates.dyslexiaFont != null ? updates.dyslexiaFont : this.state.dyslexiaFont
    };
    settings.textColor = getTextColor(settings.backgroundColor);

    this.setState(settings);
    saveReaderSettings(settings);
    applyReaderSettings(settings);
    try { window.dispatchEvent(new CustomEvent('reader-settings-changed', { detail: settings })); } catch (e) {}
  }

  toggleOpen = () => {
    this.setState(function (prev) { return { open: !prev.open }; });
  };

  changeFontSize = function (delta) {
    var current = this.state.fontSize;
    var next = current + delta;
    if (next < FONT_SIZE_MIN) next = FONT_SIZE_MIN;
    if (next > FONT_SIZE_MAX) next = FONT_SIZE_MAX;
    if (next === current) return;
    this.persistAndApply({ fontSize: next });
  };

  resetFontSize = function () {
    this.persistAndApply({ fontSize: 100 });
  };

  changeBackground = function (color) {
    if (color === this.state.backgroundColor) return;
    this.persistAndApply({ backgroundColor: color });
  };

  changeFontFamily = function (font) {
    if (font === this.state.fontFamily) return;
    this.persistAndApply({ fontFamily: font });
  };

  toggleHighContrast = function () {
    this.persistAndApply({ highContrast: !this.state.highContrast });
  };

  toggleDyslexiaFont = function () {
    this.persistAndApply({ dyslexiaFont: !this.state.dyslexiaFont });
  };

  render() {
    if (!this.state.visible && !this.state.open) return null;

    return (
      <div className="rdp-reader-settings">
        <button
          className={'rdp-reader-settings-toggle' + (this.state.open ? ' active' : '')}
          onClick={this.toggleOpen}
          aria-label="Configurar leitura"
          title="Configurar leitura"
        >
          <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
            <path d="M11 4c-4 0-6 1-6 3v10c0 2 2 3 6 3s6-1 6-3V7c0-2-2-3-6-3zm0 13c-2.2 0-4-.4-4-1s1.8-1 4-1 4 .4 4 1-1.8 1-4 1zm0-3c-2.2 0-4-.4-4-1s1.8-1 4-1 4 .4 4 1-1.8 1-4 1zm0-3c-2.2 0-4-.4-4-1s1.8-1 4-1 4 .4 4 1-1.8 1-4 1zm4-3c0 .6-1.8 1-4 1s-4-.4-4-1 1.8-1 4-1 4 .4 4 1z"/>
            <path d="M19 4h-1v2h1c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-3v2h3c2.2 0 4-1.8 4-4V8c0-2.2-1.8-4-4-4z"/>
          </svg>
        </button>

        {this.state.open && (
          <div className="rdp-reader-settings-panel">
            <div className="rdp-reader-settings-header">
              <span className="rdp-reader-settings-title">Configurar leitura</span>
              <button className="rdp-reader-settings-close" onClick={this.toggleOpen}>×</button>
            </div>

            <div className="rdp-reader-settings-section">
              <p className="rdp-reader-settings-label">Tamanho da fonte</p>
              <div className="rdp-reader-settings-size-row">
                <button
                  className="rdp-reader-settings-size-btn"
                  onClick={this.changeFontSize.bind(this, -5)}
                  disabled={this.state.fontSize <= FONT_SIZE_MIN}
                  aria-label="Diminuir fonte"
                >−</button>
                <span className="rdp-reader-settings-size-value">
                  {this.state.fontSize}%
                </span>
                <button
                  className="rdp-reader-settings-size-btn"
                  onClick={this.changeFontSize.bind(this, 5)}
                  disabled={this.state.fontSize >= FONT_SIZE_MAX}
                  aria-label="Aumentar fonte"
                >+</button>
                <button
                  className="rdp-reader-settings-size-btn rdp-reader-settings-reset-btn"
                  onClick={this.resetFontSize.bind(this)}
                  aria-label="Resetar tamanho da fonte"
                  title="Resetar"
                >↺</button>
              </div>
            </div>

            <div className="rdp-reader-settings-divider"></div>

            {!this.state.highContrast && (
              <>
                <div className="rdp-reader-settings-section">
                  <p className="rdp-reader-settings-label">Cor do fundo</p>
                  <div className="rdp-reader-settings-colors">
                    {COLORS.map(function (c) {
                      return (
                        <button
                          key={c.bg}
                          className={
                            'rdp-reader-settings-color-item' +
                            (this.state.backgroundColor === c.bg ? ' active' : '')
                          }
                          style={{ background: c.bg }}
                          onClick={this.changeBackground.bind(this, c.bg)}
                          aria-label={c.label}
                          title={c.label}
                        >
                          {this.state.backgroundColor === c.bg && (
                            <svg viewBox="0 0 24 24" width="14" height="14" fill={c.text === '#fff' ? '#fff' : '#084c8a'}>
                              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                            </svg>
                          )}
                        </button>
                      );
                    }, this)}
                  </div>
                </div>

                <div className="rdp-reader-settings-divider"></div>
              </>
            )}

            <div className="rdp-reader-settings-section">
              <p className="rdp-reader-settings-label">Fonte</p>
              <div className="rdp-reader-settings-fonts">
                {FONT_LIST.map(function (f) {
                  return (
                    <button
                      key={f}
                      className={
                        'rdp-reader-settings-font-item' +
                        (this.state.fontFamily === f ? ' active' : '')
                      }
                      style={f !== 'Padrão' ? { fontFamily: "'" + f + "', serif" } : {}}
                      onClick={this.changeFontFamily.bind(this, f)}
                    >
                      {f}
                    </button>
                  );
                }, this)}
              </div>
            </div>

            <div className="rdp-reader-settings-divider"></div>

            <div className="rdp-reader-settings-section">
              <p className="rdp-reader-settings-label">Alto contraste</p>
              <button
                className={"rdp-reader-settings-toggle-btn" + (this.state.highContrast ? ' active' : '')}
                onClick={this.toggleHighContrast.bind(this)}
                aria-checked={this.state.highContrast}
                aria-label="Alternar alto contraste"
                role="switch"
              >
                <span className="rdp-reader-settings-toggle-track">
                  <span className="rdp-reader-settings-toggle-thumb"></span>
                </span>
                <span className="rdp-reader-settings-toggle-label">
                  {this.state.highContrast ? 'Ativo' : 'Inativo'}
                </span>
              </button>
            </div>

            <div className="rdp-reader-settings-divider"></div>

            <div className="rdp-reader-settings-section">
              <p className="rdp-reader-settings-label">Fonte para dislexia</p>
              <button
                className={"rdp-reader-settings-toggle-btn" + (this.state.dyslexiaFont ? ' active' : '')}
                onClick={this.toggleDyslexiaFont.bind(this)}
                aria-checked={this.state.dyslexiaFont}
                aria-label="Alternar fonte para dislexia"
                role="switch"
              >
                <span className="rdp-reader-settings-toggle-track">
                  <span className="rdp-reader-settings-toggle-thumb"></span>
                </span>
                <span className="rdp-reader-settings-toggle-label">
                  {this.state.dyslexiaFont ? 'Ativo' : 'Inativo'}
                </span>
              </button>
            </div>
          </div>
        )}

        {this.state.open && (
          <div className="rdp-reader-settings-backdrop" onClick={this.toggleOpen}></div>
        )}
      </div>
    );
  }
}
